<template>
  <div>
    <div class="page-body">
      <el-form :model="rowForm" :rules="formRules" ref="formRef" label-position="right" label-width="100px" >
        <el-row>
          <el-col :span="6" :row="5">
            <el-form-item label="头像:">
              <el-image style="width: 200px;height:200px" :src="rowForm.avatarUrl" :fit="fit">
                <i class="el-icon-picture-outline"></i>
              </el-image>
            </el-form-item>
          </el-col>
          <el-col :span="12" :row="5" style="padding:20px 0px">
            <el-form-item label="用户名:" prop="username">
              <el-input
                style="width: 100%"
                prefix-icon="el-icon-edit"
                v-model="rowForm.username"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="昵称:" prop="nickname">
              <el-input style="width: 100%" prefix-icon="el-icon-edit" v-model="rowForm.nickname" disabled ></el-input>
            </el-form-item>

            <el-form-item label="手机:" prop="phone " class="el-form-item">
              <el-input style="width: 100%" prefix-icon="el-icon-edit" v-model="rowForm.phone" disabled ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="邮箱:" prop="email " class="el-form-item">
              <el-input style="width: 100%" prefix-icon="el-icon-edit" v-model="rowForm.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="OpenId:" prop="openId " class="el-form-item">
              <el-input
                style="width: 100%"
                prefix-icon="el-icon-edit"
                v-model="rowForm.openId"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="18">
            <el-form-item label="地址:" prop="address">
              <el-input style="width: 100%" prefix-icon="el-icon-edit" v-model="rowForm.address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="备注信息:">
              <el-input
                type="textarea"
                rows="3"
                style="width: 100%"
                prefix-icon="el-icon-edit"
                v-model="rowForm.remark"
                placeholder="请输入插座数量"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="15">&nbsp;</el-col>
        <el-col :span="9">
          <el-button type="primary" @click="doUpdate">保存修改</el-button>
        </el-col>
      </el-row>
    </div>
    <el-row>
      <div>
        <h1>| 订单列表</h1>
      </div>
    </el-row>
    <!-- 表格 start -->
    <!-- <div style="margin-top: 30px">
      <el-table :data="chargeUserOrders" stripe border v-loading="loading" element-loading-text="正在加载..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%" >
        <el-table-column type="selection" align="center" width="44"></el-table-column>
        <el-table-column prop="equipmentCode" label="充电桩编码" width="120" align="center" fixed="left"></el-table-column>
        <el-table-column prop="connectorCode" label="插座号" width="80" align="center" fixed="left"></el-table-column>
        <el-table-column prop="orderNumber" label="订单编号" width="300" align="center" fixed="left" ></el-table-column>
        <el-table-column prop="payStatus" label="订单状态" width="100" align="center" :formatter="payStatus" ></el-table-column>
        <el-table-column prop="startTime" label="开始时间 " width="180" align="center"></el-table-column>
        <el-table-column prop="endTime" label="结束时间 " width="180" align="center"></el-table-column>
        <el-table-column prop="totalMoney" label="订单金额 " width="95" align="center"></el-table-column>
        <el-table-column prop="phoneNum" label="支付人手机号" width="400" align="center"></el-table-column>
        <el-table-column prop="createTime" label="订单创建日期" width="400" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" width="400" align="center"></el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button @click="showEditOrderView(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex;justify-content: flex-end">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total, slot"
          :total="total"
        ></el-pagination>
      </div>
    </div> -->
	
	<!-- 表格 start -->
	<div style="margin-top: 30px">
		<el-table :data="chargeUserOrders" stripe border v-loading="loading" element-loading-text="正在加载..."
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
			style="width: 100%">
			<el-table-column type="selection" align="center" width="44"></el-table-column>
			<el-table-column prop="equipmentCode" label="充电桩编码" width="160" align="center" fixed="left">
			</el-table-column>
			<el-table-column prop="connectorCode" label="插座号" width="80" align="center" fixed="left">
				<template slot-scope="scope">
					<span v-if="
	        scope.row.equipmentType == 2 && scope.row.connectorCode == '1'
	      ">
						A 口
					</span>
					<span v-if="
	        scope.row.equipmentType == 2 && scope.row.connectorCode == '2'
	      ">
						B 口
					</span>
					<span v-if="scope.row.equipmentType == 1">
						{{ scope.row.connectorCode }} 号口
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="orderNumber" label="订单编号" width="240" align="center" fixed="left">
			</el-table-column>
			<el-table-column prop="payStatus" label="订单状态" width="120" align="center">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.chargingStatus == 0" type='info'>未启动</el-tag>
					<el-tag v-if="scope.row.chargingStatus == 1" type="success">充电中</el-tag>
					<el-tag v-if="scope.row.chargingStatus == 2" type="">充电完成</el-tag>
					<el-tag v-if="scope.row.chargingStatus == 3" type="warning">充电失败</el-tag>
					<el-tag v-if="scope.row.chargingStatus == 4" type="error">充电暂停</el-tag>
				</template>
			</el-table-column>
			<!-- stationName -->
			<el-table-column prop="stationName" label="小区名称" width="180" align="center"></el-table-column>
			<el-table-column prop="startTime" label="开始时间 " width="180" align="center"></el-table-column>
			<el-table-column prop="endTime" label="结束时间 " width="180" align="center"></el-table-column>
			<el-table-column prop="totalMoney" label="订单金额（元）" width="120" align="center"></el-table-column>
	
			<el-table-column prop="totalMinutes" label="设备计时（分） " width="120" align="center"></el-table-column>
	
			<el-table-column prop="totalQuantity" label="充电电量(瓦分)" width="120" align="center"></el-table-column>
	
	
			<el-table-column prop="nick" label="用户昵称" width="200" align="center"></el-table-column>
			<el-table-column prop="phone" label="支付人手机号" width="200" align="center"></el-table-column>
			<el-table-column prop="startType" label="启动方式" width="120" align="center" :formatter="formatStartType">
			</el-table-column>
			<el-table-column prop="startType" label="卡号" width="120" align="center">
				<template slot-scope="scope">
					<span v-if="scope.row.startType!=2">非刷卡启动</span>
					<span v-if="scope.row.startType==2">{{scope.row.cardNum}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="reason" label="结束方式" width="120" align="center" :formatter="formatEndMode">
			</el-table-column>
			<el-table-column prop="remark" label="备注" width="400" align="center"></el-table-column>
			<el-table-column prop="createTime" label="订单创建时间" width="100" align="center"></el-table-column>
			<el-table-column fixed="right" label="操作" width="200" align="center">
				<template slot-scope="scope">
					<el-button @click="showEditOrderView(scope.row)">查看</el-button>
					<el-button @click="doRefund(scope.row)">发起退款</el-button>
					<!-- <el-button @click="deleteUser(scope.row)" type="danger">删除</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<div style="display: flex; justify-content: flex-end">
			<el-pagination background @current-change="currentChange" @size-change="sizeChange"
				layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total"></el-pagination>
		</div>
	</div>
	<!-- 表格 END -->
	

    <!-- 详情-->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="1200px" show-close>
      <div style="height:40vh;overflow:auto">
        <el-form :model="orderForm" ref="orderDetail" label-position="right" label-width="160px">
          <el-col :span="12">
            <el-form-item label="订单编号：">
              <el-input clearable width="180px" disabled v-model="orderForm.orderNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="系统编号：">
              <el-input clearable width="180px" disabled v-model="orderForm.localOrderNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名：">
              <el-input clearable width="180px" disabled v-model="orderForm.nickname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：">
              <el-input clearable width="180px" disabled v-model="orderForm.phoneNum"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="桩编码：">
              <el-input clearable width="180px" disabled v-model="orderForm.equipmentCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接口号：">
              <el-input clearable width="180px" disabled v-model="orderForm.connectorCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开始时间：">
              <el-input clearable width="180px" disabled v-model="orderForm.startTime"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间：">
              <el-input clearable width="180px" disabled v-model="orderForm.endTime"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="卡号：">
              <el-input clearable width="180px" disabled v-model="orderForm.monthCardSn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单金额(分)：">
              <el-input clearable width="180px" disabled v-model="orderForm.totalMoney"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="充电时长(分钟)：">
              <el-input clearable width="180px" disabled v-model="orderForm.totalMinutes"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="充电电量(瓦)：">
              <el-input clearable width="180px" disabled v-model="orderForm.totalQuantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input type="textarea" clearable rows="4" disabled v-model="orderForm.remark"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
          <el-col :span="12"></el-col>
          <el-col :span="12"></el-col>
          <el-col :span="12"></el-col>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="doOrderDetailUpdate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { deleteRequest, putRequest, getRequest, postRequest, } from "../../utils/api";
import {  apiUpdate, apiGet, apiDelete } from "./api";

export default {
  name: "ChargeUser",
  data() {
    return {
      title: "", //模态窗口 标题
      searcheForm: {}, //搜索
      chargeUserOrders: [], //列表数据
      loading: false,
      dialogVisible: false, // 是否显示 模态窗口
      total: 0,
      page: 1,
      size: 10,
      fit: "fill ",
      rowId: null,
      rowOpenId: null,
      rowForm: {
        username: null,
        phone: null,
        nickname: null,
        email: null,
        openId: null,
        avatarUrl: null,
        address: null,
      },
      orderForm: {
        orderNumber: null,
      },
      formRules: {
        equipmentCode: [
          { required: true, message: "请输桩id", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
        ],
        imei: [
          { required: true, message: "请输IMEI码", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
        ],
        buildArea: [
          { required: true, message: "请输建桩位置", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
        ],
        equipmentName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
        ],
        macAddress: [
          { required: true, message: "请输入设备MAC码", trigger: "blur" },
        ],
        connectorNumber: [
          { required: true, message: "请输入插座数量", trigger: "blur" },
        ],
        remark: [{ required: true, message: "请填写备注", trigger: "blur" }],
      },
    };
  },
  created() {
    this.rowId = this.$route.query.id;
    this.rowOpenId = this.$route.openId;
    this.getUser(this.rowId);
    // this.initChargeUserOrderList(this.rowOpenId);
  },
  mounted() {},
  methods: {
    payStatus(row, column) {
      const status = row.chargingStatus;
      if (status === 0) {
        return "未启动";
      }
      if (status === 1) {
        return "充电中";
      }
      if (status === 2) {
        return "已完成";
      }
      if (status === 3) {
        return "充电失败";
      }
      if (status === 4) {
        return "故障";
      }
    },
    formatGender(row, column) {
      return row.gender == "1" ? "男" : row.gender == "0" ? "女" : "";
    },
    formatEnable(row, colum) {
      return row.enabled == true ? "是" : row.enabled == false ? "否" : "";
    },
    // 添加用户按钮
    showAddEmpView() {
      this.form = {};
      this.title = "新增";
      this.dialogVisible = true;
    },
    doOrderDetailUpdate() {
      this.dialogVisible = false;
    },
    //编辑用户按钮
    showEditOrderView(data) {
      this.title = "订单详情";
      this.orderForm = data;
      this.dialogVisible = true;
    },
    goChargingOrder(data) {
      this.$router.push({
        path: "/order/OrderView",
        query: { ...data.openId },
      });
    },
    // 删除用户
    deleteUser(data) {
      this.$confirm(
        "此操作将永久删除【" + data.nickname + "】, 是否继续?",
        "提示",
        { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
      )
        .then(() => {
          deleteRequest(`/api/charging-user/delete/${data.id}`).then((resp) => {
            if (resp) {
              this.initChargeUserList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //添加卡 && 更新卡信息
    doUpdate() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          apiUpdate(this.rowForm).then((resp)=>{
             if(resp.status==200){
                this.$message({
              type: "success",
              message: "数据更新成功！",
            });
             }
          })
        }
      });
    },
    async getUser(id) {
      const response = await apiGet(id);
      if (response.status) {
        this.rowForm = response.data;
        this.initChargeUserOrderList(this.rowForm.openId);
      }
    },doRefund(row) {
				this.$confirm("此操作将费用退回客户, 操作后无法撤回，是否继续", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}).then(() => {
					 getRequest("/api/order/refund/" + row.id).then((resp) => {
							if (resp.status == 200) {
								Message.error({
									message: resp.msg
								});
							} else {
								Message.error({
									message: resp.msg
								});
							}
						}); 
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
    // 页大小
    sizeChange(currentSize) {
      this.size = currentSize;
      this.initChargeUserOrderList();
    },
    // 选择页
    currentChange(currentPage) {
      this.page = currentPage;
      this.initChargeUserOrderList("advanced");
    },
    // 查询桩列表
    async initChargeUserOrderList() {
      this.loading = true;
      let params = { openId: this.rowForm.openId,  };
      postRequest( `/api/order/`, params,{page:this.page, size:this.size} )
      .then((resp) => {
        this.loading = false;
        if (resp.status == 200) {
          this.chargeUserOrders = resp.data.list;
          this.total = resp.data.total;
        }
      });
      this.loading = false;
    },
  },
};
</script>

<style>
.page-body {
  margin-top: 30px;
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
az89988u7frfry .el-input__inner {
  height: 40px;
}
.label-left,
.label-right {
  line-height: 40px;
  font-size: 16px;
}
.label-left {
  width: 30%;
  text-align: right;
}
.label-right {
  width: 70%;
  text-align: left;
}
</style>